'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Image, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { getStoreDisplayTime, storeIsOpen, useDecisions, usePageLayout } from '@libs/common-next';
import type { StoreService, StoreV2 } from '@libs/common-types';
import { handleServiceClick } from '@libs/experience-api';
import { constructServiceURL, serviceImages, VETERINARY } from '@/utils/store-details-services-module';
type StoreDetailsServiceLinkProps = {
  currentDate: Date;
  shouldHideVetHours: boolean;
  service: StoreService;
  store: StoreV2;
};
export function StoreDetailsServiceLink(t0) {
  const $ = _c(37);
  const {
    currentDate,
    shouldHideVetHours,
    service,
    store
  } = t0;
  const {
    isAuthenticated
  } = usePageLayout();
  const isPetsHotelLocalUrlEnabled = useDecisions("petshotel");
  let t1;
  if ($[0] !== service.ServiceName) {
    t1 = service.ServiceName.toLowerCase();
    $[0] = service.ServiceName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isVeterinary = t1 === VETERINARY;
  const shouldSuppressHours = shouldHideVetHours && isVeterinary;
  let serviceDisplayTime;
  let t2;
  if ($[2] !== currentDate || $[3] !== service.StandardStoreServiceHours || $[4] !== shouldSuppressHours || $[5] !== store) {
    const modifiedService = {
      ...store,
      StandardStoreHours: service.StandardStoreServiceHours
    };
    serviceDisplayTime = shouldSuppressHours ? undefined : getStoreDisplayTime(modifiedService, currentDate);
    t2 = shouldSuppressHours ? undefined : storeIsOpen(modifiedService, currentDate);
    $[2] = currentDate;
    $[3] = service.StandardStoreServiceHours;
    $[4] = shouldSuppressHours;
    $[5] = store;
    $[6] = serviceDisplayTime;
    $[7] = t2;
  } else {
    serviceDisplayTime = $[6];
    t2 = $[7];
  }
  const isStoreOpen = t2;
  let t3;
  if ($[8] !== isPetsHotelLocalUrlEnabled || $[9] !== service || $[10] !== store) {
    t3 = constructServiceURL(service, store, {
      isPetsHotelLocalUrlEnabled
    }) ?? "";
    $[8] = isPetsHotelLocalUrlEnabled;
    $[9] = service;
    $[10] = store;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const serviceUrl = t3;
  let t4;
  if ($[12] !== isAuthenticated || $[13] !== isVeterinary || $[14] !== serviceUrl) {
    t4 = async event => await handleServiceClick({
      authType: isAuthenticated,
      event,
      link: serviceUrl,
      shouldOpenInNewTab: isVeterinary
    });
    $[12] = isAuthenticated;
    $[13] = isVeterinary;
    $[14] = serviceUrl;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = serviceImages[service.ServiceName] ?? "";
  const t6 = `${service.ServiceName} image`;
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <Image src={t5} alt={t6} width={60} height={60} />;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = shouldSuppressHours && "store-details-services__info--centered";
  let t9;
  if ($[19] !== t8) {
    t9 = cn("store-details-services__info", t8);
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = isVeterinary ? "Veterinary Care" : service.ServiceName;
  let t11;
  if ($[21] !== t10) {
    t11 = <TextPassage size="lg">{t10}</TextPassage>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isStoreOpen || $[24] !== serviceDisplayTime || $[25] !== shouldSuppressHours) {
    t12 = !shouldSuppressHours && <TextPassage className={`store-details-hours__info--${isStoreOpen ? "open" : "closed"}`}>{serviceDisplayTime}</TextPassage>;
    $[23] = isStoreOpen;
    $[24] = serviceDisplayTime;
    $[25] = shouldSuppressHours;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t9) {
    t13 = <div className={t9}>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon name="chevron-right" size="lg" />;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== serviceUrl || $[33] !== t13 || $[34] !== t4 || $[35] !== t7) {
    t15 = <Link className="store-details-services__link" href={serviceUrl} onClick={t4} prefetch={false} target="_blank" tabIndex={0}>{t7}{t13}{t14}</Link>;
    $[32] = serviceUrl;
    $[33] = t13;
    $[34] = t4;
    $[35] = t7;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}